<button
appPreventDoubleClick
  pButton
  pRipple
  class="p-button-outlined btnBlueColored"
  pTooltip="Cancel"
  tooltipPosition="left"
  icon="fas fa-ban"
  id="cancelBtn"
  iconPos="left"
  (debounceClick)="documentCancelPhase()"
></button>
<p-dialog
  [(visible)]="display"
  [style]="{ width: '35vw' }"
  (onHide)="reloadDocumentDetail()"
  [modal]="true"
>
  <div *ngIf="errorMessages.length > 0">
    <p-messages severity="error">
      <ng-template pTemplate>
        <div>
        <span class="p-message-icon pi pi-times-circle"></span>
        <span class="p-ml-2">Please correct the following errors.</span>
        <br>
        <ul>
          <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
        </ul>
      </div>
      </ng-template>
    </p-messages>
  </div>
  <ng-template pTemplate="header">
    <b> Reason for Cancellation</b>
  </ng-template>
  <p>
    You must enter the reason why the Document Version is sent to Cancelled
    phase
  </p>
  <div class="field field-required">
    <bpt-text-input
      [ngClass]="{ 'error-highlight': mandatoryFields.reason }"
      [highlightAllOnFocus]="true"
      placeholder="Enter the Reason"
      [multiLine]="true"
      id="reasonForCancellationDescription"
      label="Reason*"
      [(ngModel)]="reason"
    >
    </bpt-text-input>
  </div>
  <ng-template pTemplate="footer">
    <p-button
    appPreventDoubleClick
      label="Confirm"
      type="submit"
      id="confirmButton"
      (debounceClick)="confirmClick()"
      class="align-right"
    >
    </p-button>
    <p-button
    appPreventDoubleClick
      styleClass="p-button-outlined"
      label="Cancel"
      type="submit"
      id="cancelButton"
      (debounceClick)="cancelClick()"
      class="align-right"
    >
    </p-button>
  </ng-template>
</p-dialog>
